import { Route, Routes } from "react-router-dom";
import TransferAdeModule from "./";

const TransferAdeRoute = () => {
  return (
    <Routes>
      <Route path="/:ade" element={<TransferAdeModule />} />
      <Route path="/*" element={<TransferAdeModule />} />
    </Routes>
  );
};

export default TransferAdeRoute;
